// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Products/Handlers/LoadVariantChildren";
import { ProductModel, UnitOfMeasureModel } from "@insite/client-framework/Types/ApiModels";


export const XngLoadRealTimePrices: any = async (props: any) => {
    const { products } = props.apiResult;

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: products!.map((o: ProductModel) => ({
                productId: o.id,
                unitOfMeasure: o.unitOfMeasures?.find((uom: UnitOfMeasureModel) => uom.isDefault)?.unitOfMeasure,
                qtyOrdered: 1,
            })),
            onComplete: realTimePricingProps => {
                if (realTimePricingProps?.apiResult) {
                    realTimePricingProps.apiResult.realTimePricingResults?.forEach(pricing => {
                        const product = products.find((product: any) => product.id === pricing.productId);
                        product.pricing = pricing;
                    });
                } else if (realTimePricingProps.error) {
                    products.forEach((product: any) => { product.failedToLoadPricing = true; });
                }
                props.pricingLoaded = true;
            },
        }),
    );

    await waitFor(() => !!props.pricingLoaded);
};

export const XngLoadRealTimeInventory: any = async (props: any) => {
    const { products } = props.apiResult;

    props.dispatch(
        loadRealTimeInventory({
            productIds: products.map((o: any) => o.id),
            onComplete: realTimeInventoryProps => {
                if (realTimeInventoryProps?.error) {
                    products.forEach((product: any) => { product.failedToLoadInventory = true; });
                } else {
                    realTimeInventoryProps?.apiResult?.realTimeInventoryResults?.forEach(inventory => {
                        const product = products.find((product: any) => product.id === inventory.productId);
                        product.inventory = inventory;
                    });
                }

                props.inventoryLoaded = true;
            },
        }),
    );

    await waitFor(() => !!props.inventoryLoaded);
};

addToChainAfter(chain, RequestDataFromApi, XngLoadRealTimePrices);
addToChainAfter(chain, XngLoadRealTimePrices, XngLoadRealTimeInventory);
